var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookingR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_23327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_23327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29844 20.4001V18.0001H2.39844V16.2001H9.29844C9.78177 16.2001 10.2026 16.3793 10.5609 16.7376C10.9193 17.0959 11.0984 17.5168 11.0984 18.0001V20.4001H9.29844ZM12.8984 20.4001V18.0001C12.8984 17.5168 13.0747 17.0959 13.4272 16.7376C13.7797 16.3793 14.2034 16.2001 14.6984 16.2001H21.5984V18.0001H14.6984V20.4001H12.8984ZM6.59844 15.0001C5.74844 15.0001 5.03594 14.7126 4.46094 14.1376C3.88594 13.5626 3.59844 12.8501 3.59844 12.0001V8.4001H20.3984V12.0001C20.3984 12.8501 20.1068 13.5626 19.5234 14.1376C18.9401 14.7126 18.2318 15.0001 17.3984 15.0001H6.59844ZM6.59844 13.2001H17.3984C17.7384 13.2001 18.0234 13.0851 18.2534 12.8551C18.4834 12.6251 18.5984 12.3401 18.5984 12.0001V10.2001H5.39844V12.0001C5.39844 12.3401 5.51344 12.6251 5.74344 12.8551C5.97344 13.0851 6.25844 13.2001 6.59844 13.2001ZM3.59844 7.2001V5.4001H8.99844V4.5001C8.99844 4.26676 9.08229 4.05843 9.24999 3.8751C9.4177 3.69176 9.62552 3.6001 9.87344 3.6001H14.1234C14.3568 3.6001 14.5609 3.69176 14.7359 3.8751C14.9109 4.05843 14.9984 4.26676 14.9984 4.5001V5.4001H20.3984V7.2001H3.59844Z",
    fill: "#d3135a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingR);
export default __webpack_public_path__ + "static/media/cooking_r.5679dee5650061b534570eef2ab5cbbb.svg";
export { ForwardRef as ReactComponent };